import { useState } from "react";
import { apiPost } from "../api/api";
import { useNavigate } from "react-router-dom";

export default function CriarProjeto() {
  const [nome, setNome] = useState("");
  const [cliente, setCliente] = useState("");
  const navigate = useNavigate();

  async function submit(e) {
    e.preventDefault();

    const res = await apiPost("/projetos", { nome, cliente });
    navigate(`/projetos/${res.id}`);
  }

  return (
    <div style={{ padding: 20 }}>
      <h1>Novo Projeto</h1>

      <form onSubmit={submit}>
        <input
          placeholder="Nome do projeto"
          value={nome}
          onChange={(e) => setNome(e.target.value)}
        />

        <input
          placeholder="Cliente"
          value={cliente}
          onChange={(e) => setCliente(e.target.value)}
        />

        <button type="submit">Criar</button>
      </form>
    </div>
  );
}
